import Image from '@atoms/Image/Image';
import Text from '@atoms/Text/Text';
import SiteEnum from '@models/enums/SiteEnum';
import { IListingFilterItem } from '@models/IListing';
import { handleHexCode } from '@utility/helpers/handleHexCode';
import classNames from 'classnames';

const ListingFilterItem = ({
  filter,
  image,
  colourHexCode,
  selected,
  isDrawerFilter,
  isLarge,
  site,
}: IListingFilterItem) => {
  const selectedColour = site === SiteEnum.B2B ? 'tw-bg-yellow' : 'tw-bg-black';
  const formattedColourHexCode = handleHexCode(colourHexCode);

  return (
    <div
      className={classNames(
        'tw-flex tw-items-center tw-gap-xxs tw-bg-transparent tw-pb-[5px] tw-text-center tw-text-black',
        isDrawerFilter ? ' ' : 'tw-w-[90px] tw-flex-col tw-py-[5px]',
        image?.url ? 'md:tw-w-[120px]' : '',
        'group'
      )}
    >
      <div
        className={classNames(
          'tw-relative tw-overflow-hidden tw-rounded-full tw-transition-colors',
          {
            // Base size for image
            'tw-h-3xl tw-w-3xl tw-bg-cover tw-object-cover tw-object-center':
              !!image?.url,

            // Fallback size with no image or colour
            'tw-h-3xl tw-w-3xl md:tw-h-[120px] md:tw-w-[120px]':
              (!image?.url && !colourHexCode) || isLarge,

            // Colour-only circle size
            'tw-h-2xl tw-w-2xl': !image?.url && !!colourHexCode,

            // Smaller size for drawer filters with colour
            'tw-h-md tw-w-md': !image?.url && !!colourHexCode && isDrawerFilter,
          },
          selected &&
            isDrawerFilter && [
              'tw-border tw-border-black',
              'after:tw-absolute after:tw-inset-[0] after:tw-box-content after:tw-block',
              "after:tw-rounded-full after:tw-border-[3px] after:tw-border-white after:tw-content-['']",
            ]
        )}
        style={{
          backgroundColor: colourHexCode ? formattedColourHexCode : '#fff',
        }}
      >
        {image?.url && (
          <Image
            aspectRatio={1}
            sizes="100"
            image={image}
            imageClasses="tw-h-full tw-w-full tw-object-cover tw-transition-transform tw-duration-300 tw-ease-out group-hover:tw-scale-125 group-focus:tw-scale-125"
          />
        )}
      </div>

      <div className="tw-relative">
        <Text
          as="p"
          variant={isDrawerFilter ? 'body-small' : 'label-12'}
          className={classNames('tw-transition-all tw-duration-300', {
            'tw-text-black': isDrawerFilter || (selected && !isDrawerFilter),
            'tw-font-semibold tw-text-black': selected && !isDrawerFilter,
            'tw-text-grey-70': !selected && !isDrawerFilter,
            'group-hover:tw-text-black group-focus:tw-text-black':
              !isDrawerFilter,
          })}
        >
          {filter.label}
        </Text>
        {!isDrawerFilter && (
          <div
            className={classNames(
              selected ? `${selectedColour} tw-w-full` : 'tw-w-0 tw-bg-grey-20',
              'tw-absolute tw-bottom-[-5px] tw-z-10 tw-h-[2px] tw-transition-all tw-duration-300 tw-ease-in-out-quart group-hover:tw-w-full group-focus:tw-w-full'
            )}
          />
        )}
      </div>
    </div>
  );
};

export default ListingFilterItem;
